import Model from 'ln/model/Model';

export class Toggle extends Model {

    public constructor() {
        super({ checked: false });
    }

    public checked: boolean;
}
